/** @module store/mutations */
import { originalState } from '@/store/state'
import router from '@/router'

// Preleva la lista di prodotti/varianti/ingredienti
export const FETCH_PVI = (state, data) => {
  state.prodVarIngr = data.body
  state.load_state.pvi = true
  state.loading_queue.splice(0, 1)
}
// Preleva il prossimo prodotto/variante/ingrediente
export const FETCH_NEXT_PVI = (state, payload) => {
  state.loading_queue.splice(0, 1)
  payload.callback(payload.data)
}

// Processa i terminali caricati dal cloud storage
export const FETCH_TERMINALS = (state, payload) => {
  state.terminals = payload ? payload.body : []
  state.load_state.terminals = true
  state.loading_queue.splice(0, 1)
  state.dataVersions.terminals = payload && payload.body[0].version ? payload.body[0].version : 0
}

// Processa gli operatori caricati dal cloud storage
export const FETCH_OPERATORS = (state, data) => {
  state.operators = data ? data.body : []
  state.load_state.operators = true
  state.loading_queue.splice(0, 1)
  state.dataVersions.operators = data && data.body[0].version ? data.body[0].version : 0
}

// Processa i diritti degli utenti
export const UPDATE_RIGHTS = (state, data) => {
  state.userRightsTemplate = data.body || []
  state.load_state.operators_rights = true
  state.loading_queue.splice(0, 1)
}

/** */
export const UPDATE_PVI = (state, payload) => {
  if (payload.data == 'DELETED') {
    let id = payload.ref.replace('DEL-', '')
    state.prodVarIngr.forEach((pvi, index, arr) => {
      if (pvi._id == id) arr.splice(index, 1)
      pvi.varIngr.forEach((v, vI, vArr) => {
        if (v == id) vArr.splice(vI, 1)
      })
    })
    state.tags.forEach((tag, index, arr) => {
      tag.varIngr.forEach((v, vI, vArr) => {
        if (v == id) vArr.splice(vI, 1)
      })
    })

    state.loading_queue.splice(0, 1)
  } else {
    let oldIndex = state.prodVarIngr.findIndex(pvi => pvi._id == payload.data._id)
    if (oldIndex == -1) state.prodVarIngr.push(payload.data)
    else Vue.$set(state.prodVarIngr, oldIndex, payload.data)
    state.loading_queue.splice(0, 1)
  }

  payload.callback()
}

/** */
export const SEARCH_IMAGES = (state, payload) => {
  state.loading_queue.splice(0, 1)
  payload.callback(payload.data)
}

/** */
export const FETCH_MENU = (state, data) => {
  state.menu = data.body
  state.menu.forEach(element => {
    if (!element.hasOwnProperty('menuDiscount')) {
      element.menuDiscount = {
        homeValue: '0',
        shopValue: '0',
        homeIsPercentage: false,
        shopIsPercentage: false
      }
    }

    if (!element.hasOwnProperty('deliveryPriceModifiers')) {
      element.deliveryPriceModifiers = {
        chargeFee: '0',
        freeDeliveryThreshold: '0',
        chargeType: 'fixed',
        minimumDeliverableOrder: '0'
      }
    }

    if (!element.hasOwnProperty('googleMatrixDeliveryCostPerDistance')) {
      element.googleMatrixDeliveryCostPerDistance = [
        {
          isActive: true,
          type: 'distance',
          cost: '',
          distanceThreshold: '',
          minCostThresholdForCustomCost: '',
          customCost: '',
          minimumOrderThreshold: ''
        },
        {
          isActive: false,
          type: 'distance',
          cost: '',
          distanceThreshold: '',
          minCostThresholdForCustomCost: '',
          customCost: '',
          minimumOrderThreshold: ''
        },
        {
          isActive: false,
          type: 'distance',
          cost: '',
          distanceThreshold: '',
          minCostThresholdForCustomCost: '',
          customCost: '',
          minimumOrderThreshold: ''
        },
        {
          isActive: false,
          type: 'distance',
          cost: '',
          distanceThreshold: '',
          minCostThresholdForCustomCost: '',
          customCost: '',
          minimumOrderThreshold: ''
        },
        {
          isActive: false,
          type: 'distance',
          cost: '',
          distanceThreshold: '',
          minCostThresholdForCustomCost: '',
          customCost: '',
          minimumOrderThreshold: ''
        }
      ]
    }
  })

  console.log(state.menu)

  state.load_state.menu = true
  state.loading_queue.splice(0, 1)
}
/** */
export const FETCH_MENU_ROWS = (state, payload) => {
  state.loading_queue.splice(0, 1)

  payload.callback(
    (payload.data || []).map(row =>
      Object.assign(row, {
        uploadImg: null,
        base64: null
      })
    )
  )
}
/** */
export const UPDATE_MENU = (state, payload) => {
  if (payload.data == 'DELETED') {
    const reference = payload.ref.split('-')[1]
    const menuIndex = state.menu.findIndex(menu => menu._id == reference)

    state.menu.splice(menuIndex, 1)
  } else {
    let oldIndex = state.menu.findIndex(menu => menu._id == payload.data._id)

    if (oldIndex == -1) state.menu.push(payload.data)
    else Vue.$set(state.menu, oldIndex, payload.data)
  }

  state.loading_queue.splice(0, 1)
  payload.callback()
}
/** */
export const UPDATE_MENU_ROWS = (state, payload) => {
  state.loading_queue.splice(0, 1)
  payload.callback()
}
/** */
export const FETCH_TAGS = (state, data) => {
  state.tags = data.body
  state.load_state.tags = true
  state.loading_queue.splice(0, 1)
}
/** */
export const UPDATE_TAG = (state, payload) => {
  if (payload.data == 'DELETED') {
    let tagIndex = state.tags.findIndex(tag => tag._id == payload.ref.replace('DEL-', ''))
    state.tags.splice(tagIndex, 1)
    state.loading_queue.splice(0, 1)
  } else {
    let oldIndex = state.tags.findIndex(tag => tag._id == payload.data._id)
    if (oldIndex == -1) state.tags.push(payload.data)
    else Vue.$set(state.tags, oldIndex, payload.data)
    state.loading_queue.splice(0, 1)
  }

  payload.callback()
}
/** */
export const FETCH_NEXT_TAG = (state, payload) => {
  state.loading_queue.splice(0, 1)
  payload.callback(payload.data)
}
/** */
export const FETCH_TAVOLI = (state, data) => {
  state.tavoli = data.body
  state.load_state.tavoli = true
  state.loading_queue.splice(0, 1)
}
/** */
export const UPDATE_TAVOLO = (state, payload) => {
  if (payload.data == 'DELETED') {
    let tavoloIndex = state.tavoli.findIndex(tavolo => tavolo._id == payload.ref.replace('DEL-', ''))
    state.tavoli.splice(tavoloIndex, 1)
    state.loading_queue.splice(0, 1)
  } else {
    let oldIndex = state.tavoli.findIndex(tv => tv._id == payload.data._id)
    if (oldIndex == -1) state.tavoli.push(payload.data)
    else Vue.$set(state.tavoli, oldIndex, payload.data)
    state.loading_queue.splice(0, 1)
  }

  payload.callback()
}
/** */
export const DOWNLOAD_TAVOLI = (state, payload) => {
  payload.callback(payload.data)
  state.loading_queue.splice(0, 1)
}
/** */
export const FETCH_NEXT_TV = (state, payload) => {
  state.loading_queue.splice(0, 1)
  payload.callback(payload.data)
}
/** */
export const FETCH_LISTINI = (state, data) => {
  state.listini = data.body

  if (state.currentListino == null) state.currentListino = state.listini.find(listino => listino.main)._id

  state.load_state.listini = true
  state.loading_queue.splice(0, 1)
}
/** */
export const UPDATE_LISTINO = (state, payload) => {
  if (payload.data == 'DELETED') {
    let listiniIndex = state.listini.findIndex(listino => listino._id == payload.ref)
    state.listini.splice(listiniIndex, 1)
  } else {
    let oldIndex = state.listini.findIndex(listino => listino._id == payload.data._id)
    if (oldIndex == -1) state.listini.push(payload.data)
    else Vue.$set(state.listini, oldIndex, payload.data)
    state.loading_queue.splice(0, 1)
  }

  payload.callback()
}
/** */
export const TOOLBAR_ACTIONS = (state, actions) => {
  state.toolbarActions = actions
}
/** */
export const TOOLBAR_TITLE = (state, title) => {
  state.toolbarTitle = title
}
/** */
export const SET_LISTINO = (state, listino) => {
  state.currentListino = listino
}
/** */
export const API_FAILURE = (state, error) => {
  console.log('ERROR', error)
  state.lastError = { msg: error, tms: new Date() }
  state.loading_queue.splice(0, 1)
}
/** */
export const PUSH_ERROR = (state, error) => {
  state.lastError = { msg: { status: -1, body: error }, tms: new Date() }
}
/** */
export const PUSH_MESSAGE = (state, msg) => {
  state.lastMessage = { msg: msg, tms: new Date() }
}
/** */
export const PUSHLOADING = state => {
  state.loading_queue.push(1)
}
/** */
export const POPLOADING = state => {
  state.loading_queue.splice(0, 1)
}
/** */
export const LOGIN = (state, response) => {
  state.auth = { isLoggedIn: true, accessToken: response.body.token }
  state.loading_queue.splice(0, 1)
  router.push({ name: 'home' })
}
/** */
export const LOGOUT = state => {
  Object.assign(state, originalState)
  router.push({ name: 'login' })
}
/** */
export const LOADING = state => {
  state.loading_queue.push(1)
}
/** */
export const UPDATESETTINGS = (state, newSettings) => {
  state.user.settings = newSettings
  state.lastMessage = {
    msg: 'Profilo aggiornato con successo',
    tms: new Date()
  }
  state.loading_queue.splice(0, 1)
}
/** */
export const GET_CURRENT_USER = (state, data) => {
  console.log('CURRENT USER', data)
  state.user = data.body
  state.load_state.user = true
  state.loading_queue.splice(0, 1)
}
/** */
export const FETCH_ORDINI = (state, data) => {
  data.callback(data.data)
  state.loading_queue.splice(0, 1)
}
/** */
export const CHECK_ORDINE = (state, payload) => {
  payload.callback(payload.data)
}
/** */
export const RISTAMPA = (state, payload) => {
  state.loading_queue.splice(0, 1)
  payload.callback(payload.data)
}
/** */
export const GETALLERGENI = (state, data) => {
  state.allergeni = data.body
  state.load_state.allergeni = true
  state.loading_queue.splice(0, 1)
}
/** */
export const LOCK = state => {
  state.lock = true
}
/** */
export const CHANGED = state => {
  state.changed = true
}
/** */
export const LIB_SELECTED_TAB = (state, payload) => {
  state.libSelectedTab = payload
}

/** */
export const HANDLE_LIB_FILTER = (state, { tag, target }) => {
  if (tag.tipo == 'GOBACK') {
    state.filters[target].specific = null
    state.filters[target].selected = state.tags.find(t => t._id == state.filters[target].selected.padre) || null
    return
  }

  if (state.tags.filter(t => t.padre == tag._id).length > 0) {
    state.filters[target].selected = tag
    state.filters[target].specific = tag
  } else {
    if (state.filters[target].specific === tag) {
      state.filters[target].specific = null
    } else {
      state.filters[target].specific = tag
    }
  }
}

export const RESET_LIB_FILTER = (state, { target }) => {
  state.filters[target].specific = null
  state.filters[target].selected = null
}

// payment mutations

export const FETCH_PAYMENTS = (state, data) => {
  if (data) {
    state.paymentTypes = data.body
    state.dataVersions.paymentTypes = 0
  } else {
    state.paymentTypes = []
  }

  state.load_state.paymentTypes = true
  state.loading_queue.splice(0, 1)
}

// discount mutations

export const FETCH_DISCOUNTS = (state, data) => {
  if (data) {
    state.discountTypes = data.body
    state.dataVersions.discountTypes = 0
  } else {
    state.discountTypes = []
  }

  state.load_state.discountTypes = true
  state.loading_queue.splice(0, 1)
}

export const FETCH_ITALIAN_CITIES = (state, data) => {
  state.italianCities = data.body
  state.loading_queue.splice(0, 1)
}



// WEBPACK FOOTER //
// ./src/store/mutations.js